import React from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { PublicNavbar } from "./layout/PublicNavbar";
import { Footer } from "./layout/Footer";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const { t } = useTranslation();

  return (
    <Box>
      <PublicNavbar />
      <Box bg={bgColor} pt={80} pb={40}>
        <VStack spacing={8} textAlign="center">
          <Heading size="4xl">{t("common.notFound.title")}</Heading>
          <Heading size="xl">{t("common.notFound.heading")}</Heading>
          <Text fontSize="lg">{t("common.notFound.description")}</Text>
          <Button colorScheme="blue" size="lg" onClick={() => navigate("/")}>
            {t("common.notFound.button")}
          </Button>
        </VStack>
      </Box>
      <Footer />
    </Box>
  );
};
